<template lang="pug">
.logo(@click="$emit('click')", :class="{ fixed }")
  img(
    src="https://www.iage-france.com/wp-content/uploads/2022/09/IAGE_MAQUETTE_4V_V1-1.png"
  )
</template>


<script>
export default {
  name: "logo",
  props: ["fixed"],
};
</script>
<style lang="stylus">
.logo {
  width: 70px;
  height: 70px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
  }

  &.fixed {
    padding: 15px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    border-radius: 50%;
    margin: 10px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
  }
}
</style>

